
// Define Change Model Constant
export const DATASET_ID_CHANGE = "DATASET_ID_CHANGE";
export type DATASET_ID_CHANGE = typeof DATASET_ID_CHANGE;

export const API_ID_CHANGE = "API_ID_CHANGE";
export type API_ID_CHANGE = typeof API_ID_CHANGE;


export const API_ID_LIST_CHANGE = "API_ID_LIST_CHANGE";
export type API_ID_LIST_CHANGE = typeof API_ID_LIST_CHANGE;

export const TASK_ID_CHANGE = "TASK_ID_CHANGE";
export type TASK_ID_CHANGE = typeof TASK_ID_CHANGE;

export const MODE_ID_CHANGE = "MODE_ID_CHANGE";
export type MODE_ID_CHANGE = typeof MODE_ID_CHANGE;

export const INIT_DATASET_LIST = "INIT_DATASET_LIST";
export type INIT_DATASET_LIST = typeof INIT_DATASET_LIST;

export const CLEAR_ID_INFO = "CLEAR_ID_INFO";
export type CLEAR_ID_INFO = typeof CLEAR_ID_INFO;

export const INIT_DATA = "INIT_DATA";
export type INIT_DATA = typeof INIT_DATA;

export const INIT_EXPLORE_META_DATA = "INIT_EXPLORE_META_DATA";
export type INIT_EXPLORE_META_DATA = typeof INIT_EXPLORE_META_DATA;

export const VIEW_MODE_CHANGE = "VIEW_MODE_CHANGE";
export type VIEW_MODE_CHANGE = typeof VIEW_MODE_CHANGE;

export const CHANGE_EXPLORE_LOADING = "CHANGE_EXPLORE_LOADING";
export type CHANGE_EXPLORE_LOADING = typeof CHANGE_EXPLORE_LOADING;